/* ==========================================================================
   TAVLOVA — EMOJI BURST
   Emojis shoot up out of the Add to cart button, arc outwards, then fall
   and fade, like confetti. Fires only after the item has actually been
   added (Dawn publishes cartUpdate from the product form on success).
   Emojis and amount come from the "Tavlova product extras" section.
   Skipped for visitors with reduced motion switched on.
   ========================================================================== */

(function () {
  var config = document.querySelector('[data-tv-emoji-rain]');
  if (!config) return;

  var emojis = (config.dataset.emojis || '').trim().split(/\s+/).filter(Boolean);
  if (!emojis.length) emojis = ['\uD83E\uDD5D', '\uD83D\uDC11', '\uD83C\uDFC9', '\uD83C\uDF7A', '\uD83D\uDD25'];
  var count = parseInt(config.dataset.count, 10) || 30;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Remember which Add to cart button was pressed, and where it was at the
     moment of the click — the cart drawer can shift things afterwards. */
  var origin = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    origin = { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width };
  }, true);

  function fallbackOrigin() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return { x: window.innerWidth / 2, y: window.innerHeight * 0.7, w: 200 };
    var r = btn.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width };
  }

  function burst() {
    if (reduceMotion.matches) return;
    if (!document.body.animate) return;

    var o = origin || fallbackOrigin();
    origin = null;

    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText =
      'position:fixed;inset:0;z-index:2147483000;overflow:hidden;pointer-events:none;';
    document.body.appendChild(layer);

    var GRAVITY = 1500;   /* px per second squared */
    var STEPS = 14;
    var longest = 0;

    for (var i = 0; i < count; i++) {
      var drop = document.createElement('span');
      drop.textContent = emojis[Math.floor(Math.random() * emojis.length)];

      var startX = o.x + (Math.random() - 0.5) * o.w * 0.6;
      drop.style.cssText =
        'position:absolute;line-height:1;will-change:transform,opacity;' +
        'left:' + startX + 'px;top:' + o.y + 'px;' +
        'font-size:' + (2.2 + Math.random() * 2.6) + 'rem;';
      layer.appendChild(drop);

      /* Fan upwards: straight up ± 70 degrees. */
      var angle = (-90 + (Math.random() * 140 - 70)) * Math.PI / 180;
      var speed = 450 + Math.random() * 550;
      var vx = Math.cos(angle) * speed;
      var vy = Math.sin(angle) * speed;
      var spin = Math.random() * 720 - 360;
      var duration = 1.3 + Math.random() * 0.7;
      var delay = Math.random() * 0.12;
      longest = Math.max(longest, duration + delay);

      var frames = [];
      for (var s = 0; s <= STEPS; s++) {
        var p = s / STEPS;
        var t = duration * p;
        var dx = vx * t;
        var dy = vy * t + 0.5 * GRAVITY * t * t;
        var scale = s === 0 ? 0.3 : 1;
        var opacity = p < 0.7 ? 1 : 1 - (p - 0.7) / 0.3;
        frames.push({
          transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) rotate(' + (spin * p) + 'deg) scale(' + scale + ')',
          opacity: opacity
        });
      }

      drop.animate(frames, {
        duration: duration * 1000,
        delay: delay * 1000,
        easing: 'linear',
        fill: 'both'
      });
    }

    setTimeout(function () { layer.remove(); }, (longest + 0.3) * 1000);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') burst();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
